import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken  } from "../Global";
import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";

const RawMaterialPricingView = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({}); 
   const [permission, setPermission] = useState({});

  const [currencySymbol, setCurrencySymbol] = useState('');
  useEffect(() => {
        setPermission(FindModuleById(191)); 
console.log(permission);

   
     axios
      .get(`/raw-materials/view/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.raw);
          console.log(response.data.data.raw);
          axios.get(`/helper/currency-symbol-by-currency-id/${response.data.data.raw.currency}`, {
            headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          })
          .then((response) => {
            if (response.data.code === 200) {
            // console.log(response.data.data);
              setCurrencySymbol(response.data.data.currency_symbol)
            
            }
          })
          .catch((error) => {
            console.log(error);
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  let raw_data_invoice ='';
  if(value.invoice){
    AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
    AWS.config.update({
    accessKeyId: AWS_ACCESS_KEY_ID,
    secretAccessKey: AWS_SECRET_ACCESS_KEY,
    region: AWS_DEFAULT_REGION,
    signatureVersion: 'v4',
    });
    const s3 = new AWS.S3();
    var params = {Bucket: AWS_BUCKET, Key: value.invoice};
    raw_data_invoice = s3.getSignedUrl('getObject', params);
  
  }
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Raw Material Pricing</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/raw-material-pricing">Raw Material Pricing</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      View Raw Material
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {permission && permission.update === 1 && (
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">View Raw Material Info</h4>
                    <table className="table table-bordered">
                    <tr>
                        <th className="p-3">Lot Number</th>
                        <td className="p-3">{value.lot_number}</td>
                      </tr> <tr>
                        <th className="p-3">Plate Number</th>
                        <td className="p-3">{value.plate_number}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Driver Name</th>
                        <td className="p-3">{value.driver_name}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Farmer Name</th>
                        <td className="p-3">
                          {value.farmer_detail ? value.farmer_detail.name : ""}
                        </td>
                      </tr>
                      
                      <tr>
                        <th className="p-3">Location</th>
                        <td className="p-3">
                          {value.location ? value.location_name.title : ""}
                        </td>
                      </tr>
                      <tr>
                        <th className="p-3">Shift Date</th>
                        <td className="p-3">{value.shift_date}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Supplier Name</th>
                        <td className="p-3">
                          {value.supplier ? value.supplier_name.name : ""}
                        </td>
                      </tr>
                     
                      {/* <tr>
                        <th className="p-3">BL Net Weight</th>
                        <td className="p-3">{value.net_weight}KG</td>
                      </tr>
                      <tr>
                        <th className="p-3">BL Gross Weight</th>
                        <td className="p-3">{value.gross_weight}KG</td>
                      </tr> */}

                      <tr>
                        <th className="p-3">Grade A Net Weight</th>
                        <td className="p-3">{value.grade_a_net_weight}KG</td>
                      </tr>
                      <tr>
                        <th className="p-3">Grade A Net Weight</th>
                        <td className="p-3">{value.grade_b_net_weight}KG</td>
                      </tr>
                    
                     

                     
                      <tr>
                        <th className="p-3">Grade A Price</th>
                        <td className="p-3">{parseFloat(value.grade_a_price).toFixed(2)}{currencySymbol}</td>
                      </tr>
                     
                     
                      <tr>
                        <th className="p-3">Grade B Price</th>
                        <td className="p-3">{parseFloat(value.grade_b_price).toFixed(2)}{currencySymbol}</td>
                      </tr>
                     

                      <tr>
                        <th className="p-3">Total Amount</th>
                        <td className="p-3">{parseFloat(value.total_amount).toFixed(2)}{currencySymbol}</td>
                      </tr>

                      
                  
                      

                      {raw_data_invoice != '' && (
                          <tr>
                          <th className="p-3">Invoice</th>
                          <td className="p-3">
                            <a
                              className="btn btn-primary invoicebtn"
                              href={raw_data_invoice}
                              target="_blank"
                              download
                              rel="noopener noreferrer"

                            >
                              Download
                            </a>
                          </td>
                        </tr>
                      )}
                       

                    </table>
                  </div>
                </div>
              </div>
            </div> )}
                {permission && permission.update === 1 && (
                    <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title">Palletesation Details</h5>

                    <table className="table table-bordered  text-center">
                          <thead>
                          <tr>
                            <th className="">Barcode</th>
                            <th className=" text-center">Product</th>
                            <th className="text-center">Type</th>
                            <th className="text-center">Gross Weight</th>
                            <th className="text-center">Net Weight</th>
                            <th className="text-center">Number oF Boxes</th>
                     
                          </tr>
                          </thead>
                          <tbody>
                          {value.palletesations &&
                          value.palletesations.map((item,indx) => (
                            <tr   key={item.barcode || indx}>
                              {/* <td style={{textAlign:'center'}} className=""> <a href={'/raw-materials-view/'+item.raw_material_id} style={{display:'block'}}  >
                                  {item.barcode}
                                </a></td> */}
                              <td className="">{item.barcode}</td>
                              <td className="">{item.productname}</td>
                              <td className="">{item.type_name}</td>
                              <td className="text-center">{item.gross_weight} (KG)</td>
                              <td className="text-center">{item.net_weight} (KG)</td>
                              <td className="text-center">{item.number_of_boxes}</td>

                            </tr>
                          ))}
                          
                          </tbody>
                      
                    </table>
                  </div>
                </div>

               
              </div>
            </div>
                )}
                 <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-body">
                        <h5 className="card-title">Quality Check</h5>
                        <table className="table table-bordered">
                      <thead>
                      <tr>
                        <th>Sample Number</th>
                        <th>Sample Size (g)</th>
                        <th>Unripe Fruits (%)</th>
                        <th>Ripe Fruits(%)</th>
                        <th>Deformed Fruits(%)</th>
                        <th>Decision</th>
                        <th>Remarks</th>
                      </tr>
                      </thead>
                      

                      {value.checklist &&
                        value.checklist.map((item, indx) => (
                          <tr  key={item.calibre || indx}>
                            <td className="p-3">{item.simple_number}</td>
                            <td className="p-3">{item.simple_size}</td>
                            <td className="p-3">{item.unripe_fruits.toFixed(2)}</td>
                            <td className="p-3">{item.ripe_fruits.toFixed(2)}</td>
                            <td className="p-3">{item.deformed_fruits.toFixed(2)}</td>
                            <td className="p-3">{item.decision}</td>
                            <td className="p-3">{item.remarks}</td>
                          </tr>
                        ))}
                        <tr>
                          <td className="p-3" style={{fontWeight:'bold'}}>Total</td>
                          <td className="p-3"  style={{fontWeight:'bold'}}>{value.simple_size_sum}(g)</td>
                          <td className="p-3" style={{fontWeight:'bold'}}>{value.unripe_fruits_percentage}%</td>
                          <td className="p-3" style={{fontWeight:'bold'}}>{value.ripe_fruits_percentage}%</td>
                          <td className="p-3" style={{fontWeight:'bold'}}>{value.deformed_fruits_percentage}%</td>
                          <td className="p-3" style={{fontWeight:'bold'}}></td>
                          <td className="p-3" style={{fontWeight:'bold'}}></td>
                      </tr>
                    </table>
                      </div>
                    </div>
                  </div>
                </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default RawMaterialPricingView;
